import { getTermsValue, resetTerms, setTerms } from '../../../../JsonQuery';
import { TTagsManager } from '../../types/tag';
import { createTagValue } from '../../utils/createTagValue';
import { EPlacementType } from '../../../../api-models/common/json_query';

const ID = 'placementType' as const;

const PLACEMENT_TYPE_MAP_VALUE_TO_LABEL: Record<EPlacementType, string> = {
  [EPlacementType.StreetRetail]: 'Первый этаж здания',
  [EPlacementType.ShoppingMall]: 'В торговом комплексе',
};

export const placementTypeTagsManager: TTagsManager = {
  id: ID,
  extractTagsFromJsonQuery: ({ jsonQuery }) => {
    const placementTypes = getTermsValue('placement_type')(jsonQuery);

    if (placementTypes === null) {
      return null;
    }

    return placementTypes.map(placementType => ({
      label: PLACEMENT_TYPE_MAP_VALUE_TO_LABEL[placementType],
      value: createTagValue(ID, placementType.toString()),
    }));
  },
  modifyJsonQueryByRemovingTag: ({ jsonQuery, removingTagValue }) => {
    const placementTypes = getTermsValue('placement_type')(jsonQuery);

    if (placementTypes === null) {
      return jsonQuery;
    }

    const next = placementTypes.filter(p => String(p) !== removingTagValue);

    return next.length > 0 ? setTerms('placement_type')(jsonQuery)(next) : resetTerms(['placement_type'])(jsonQuery);
  },
};
